import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Error } from './error';
import { ModalService } from '../modal/modal.service';


@Injectable()
export class ErrorHandlerService {
	error: Error = new Error();

	constructor(private router: Router, private modalService: ModalService) { }

	execute() {
		return this.executeValidationException();
	}

	executeValidationException() {
		return this.router.navigate(['/erro']);
	}

}
